/*                                       */
import { getStoreType } from "../store/utils.js";
import type { TargetStore } from "../store/store.types.js";
import type { AssignOptions } from "../proxy/proxy.types.js";
import type { AnyFunction } from "./utils.types.js";

/**
 *
 */
export const storeFlags = ["isNs", "isSig", "isFunc"] as const satisfies (keyof TargetStore)[];

const buildMessage = (store: TargetStore, action: string): string =>
  "Can not ".concat(
    action,
    " ",
    store.path,
    " because is has been already initialized as ",
    getStoreType(store),
  );

/**
 *
 *
 */
export function assertFunction(store: TargetStore, value: unknown): asserts value is AnyFunction {
  if (typeof value !== "function")
    throw new TypeError(
      `Unexpected Input for: ${store.path}. Nexus expects input to be a function, but received : ${typeof value}`,
    );
}

/**
 *
 *
 *
 *
 *
 *
 */
export function assertNamespaceFree(
  store: TargetStore,
  action: string,
  options: AssignOptions = {},
): void {
  if (store.isReady) throw Error(buildMessage(store, action));
  store.isReady = (options.lock as never) ?? true;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function assertNamespaceType(
  store: TargetStore,
  flag: (typeof storeFlags)[number],
  action: string,
): void {
  /*                        */
  if (store.isReady && storeFlags.map((f) => f !== flag && store[f]).some(Boolean))
    throw Error(buildMessage(store, action));

  /*                            */
  store[flag] = true as never;
}
